module.exports = __webpack_public_path__ + "static/media/home-img.36729052.jpg";